import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import Container from "./container";
import Newsletter from "./newsletter";
import Icon from "./icon";
import { cn } from "../lib/helpers";

import * as styles from "../styles/components/footer.module.css";
import * as styles2 from "../styles/components/newsletter.module.css";
import FooterNewsLetter from "./footer-newsletter";

const query = graphql`
  query FooterQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
    }

    footerMenu: sanityMenu(title: { eq: "Footer Menu" }) {
      menuItems {
        _key
        text
        subMenu {
          _key
          blank
          url
          text
          description
        }
      }
    }

    bottomLinks: sanityMenu(title: { eq: "Bottom Links" }) {
      menuItems {
        _key
        blank
        url
        text
      }
    }
  }
`;

const Footer = () => {
  function handleToggleSubNav(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle(styles.active);
  }

  function handleHideOverlay() {
    const parents = document.getElementsByClassName("menu-has-children");
    const filter = document.getElementById("filter");

    document.body.classList.remove("overlay-active");

    if (parents) {
      for (const parent of parents) {
        parent.classList.remove("active");
      }
    }

    if (filter) {
      filter.classList.remove("active");

      setTimeout(() => {
        filter.classList.remove("on-top");
      }, 250);
    }
  }

  return (
    <StaticQuery
      query={query}
      render={(data) => (
        <footer className={styles.root}>
          <Newsletter />
          <div className={cn(styles.top, "color-palette-border-light")}>
            <Container footerContainer>
              {data.footerMenu &&
                data.footerMenu.menuItems &&
                data.footerMenu.menuItems.length > 0 && (
                  <div className={styles.footerMenu}>
                    {data.footerMenu.menuItems.map((menuItem, i) => {
                      return (
                        <div
                          className={cn(
                            styles.item,
                            i < data.footerMenu.menuItems.length - 2 &&
                              styles.itemAccordion,
                            i < data.footerMenu.menuItems.length - 2 &&
                              "color-palette-border-light",
                            (i === data.footerMenu.menuItems.length - 2 ||
                              i === data.footerMenu.menuItems.length - 1) &&
                              styles.regularList,
                            i === data.footerMenu.menuItems.length - 1 &&
                              styles.dHide
                          )}
                          key={menuItem._key}
                        >
                          {menuItem.text && (
                            <div
                              className={styles.heading}
                              onClick={handleToggleSubNav}
                            >
                              {menuItem.text}
                              {i < data.footerMenu.menuItems.length - 2 && (
                                <div
                                  className={cn(
                                    styles.icon,
                                    styles.dHide,
                                    "color-palette-svg-stroke"
                                  )}
                                >
                                  <Icon symbol="chevron-down" />
                                </div>
                              )}
                            </div>
                          )}

                          {menuItem.subMenu && menuItem.subMenu.length > 0 && (
                            <ul className={styles.subMenu}>
                              {menuItem.subMenu.map((menuItem) => {
                                return (
                                  <li key={menuItem._key}>
                                    {menuItem.blank ? (
                                      <a
                                        href={menuItem.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={cn(
                                          styles.isExternal,
                                          "color-palette-color-underline color-palette-svg-stroke"
                                        )}
                                      >
                                        {menuItem.text}
                                        <Icon symbol="external" />
                                        {menuItem.description && (
                                          <span
                                            className={cn(
                                              styles.description,
                                              "color-palette-bg"
                                            )}
                                          >
                                            {menuItem.description}
                                          </span>
                                        )}
                                      </a>
                                    ) : (
                                      <Link
                                        to={menuItem.url}
                                        className="color-palette-color-underline"
                                      >
                                        {menuItem.text}
                                        {menuItem.description && (
                                          <span
                                            className={cn(
                                              styles.description,
                                              "color-palette-bg"
                                            )}
                                          >
                                            {menuItem.description}
                                          </span>
                                        )}
                                      </Link>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </div>
                      );
                    })}
                    <div
                      className={cn(
                        "col-12 col-sm-6",
                        styles2.col,
                        styles2.form,
                        styles.itemFooter
                      )}
                    >
                      <FooterNewsLetter />
                    </div>
                  </div>
                )}
            </Container>
          </div>

          <div className={styles.bottom}>
            <Container footerContainer>
              <div className="grid justify-lg-between">
                <div className="col-12 col-lg-auto">
                  <div className={styles.copyright}>
                    &copy;{new Date().getFullYear()} {data.site.title}
                  </div>
                </div>
                <div className={cn("col-12 col-lg-auto", styles.mHide)}>
                  {data.bottomLinks &&
                    data.bottomLinks.menuItems &&
                    data.bottomLinks.menuItems.length > 0 && (
                      <nav>
                        <ul className={styles.bottomLinks}>
                          {data.bottomLinks.menuItems.map((menuItem) => (
                            <li key={menuItem._key}>
                              {menuItem.blank ? (
                                <a
                                  href={menuItem.url}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="color-palette-color"
                                >
                                  {menuItem.text}
                                </a>
                              ) : (
                                <Link
                                  to={menuItem.url}
                                  className="color-palette-color"
                                >
                                  {menuItem.text}
                                </Link>
                              )}
                            </li>
                          ))}
                        </ul>
                      </nav>
                    )}
                </div>
              </div>
            </Container>
          </div>
          <div className={styles.overlay} onClick={handleHideOverlay}></div>
        </footer>
      )}
    />
  );
};

export default Footer;
